// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2by6U","label":"LabeledBox_label__1Wl9D"};